/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { Step } from '@/pages/projects/LiveAgentTypes';

export const getAllSteps = (steps: Step[]): Step[] => {
    return steps.flatMap((s) => {
        if (s.kind === 'block' && s.steps) {
            return [s, ...getAllSteps(s.steps)];
        }
        return [s];
    });
};
